import React from "react"
import { RouteObject } from "react-router-dom"
// import NewPropertyComponent from "../component/new-property-component";
// import PropertyPage from "../page/property.page";
import LeasePage from "../page/lease.page"
import AuthGuard from "../../../shared/auth/component/auth"
import NewLeaseComponent from "../component/new-lease-component"
export const LeaseRoute: RouteObject = {
  path: "/lease",
  element: (
    <AuthGuard role={["super_admin", "owner"]} permission={["manage-leases", "view-leases"]}>
      <LeasePage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewLeaseComponent editMode="detail" />,
    },
    { path: ":id", element: <NewLeaseComponent editMode="new" /> },
  ],
}
